import ScreenWrapper from "@/components/ScreenWrapper"
import { createFileRoute } from "@tanstack/react-router"
import { Button, FormStyle, PageHeader } from "toptaal-shared"
import { useRouter } from "@tanstack/react-router"
import RoleBasedComponent from "@/components/RolebasedComponent"
import { checkPermissions } from "@/utils/checkPermissions"
import IntakeForm from "@/components/forms/intake/IntakeForm"

export const Route = createFileRoute("/beheer/intakes/aanmaken")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("create", "intake"),
})

function RouteComponent() {
  const router = useRouter()

  return (
    <ScreenWrapper className="mt-8" showManagementMenu>
      <section className="w-full">
        <FormStyle className="mx-auto max-w-2xl">
          <RoleBasedComponent permissions="create" entity="intake">
            <PageHeader className="mb-10 text-center">Nieuwe intake</PageHeader>
          </RoleBasedComponent>

          <IntakeForm
            type="create"
            SubmitButton={(isValid, isPending) => (
              <div className="col-span-2 flex justify-end gap-4 mt-8">
                <Button
                  type="button"
                  variant="secondary"
                  data-testid="cancel-button"
                  onClick={() => {
                    router.navigate({ to: "/beheer/intakes" })
                  }}
                >
                  Annuleren
                </Button>
                <Button
                  type="submit"
                  variant="primary"
                  isLoading={isPending}
                  disabled={!isValid}
                  data-testid="submit-button"
                >
                  Aanmaken
                </Button>
              </div>
            )}
          />
        </FormStyle>
      </section>
    </ScreenWrapper>
  )
}
